import { render } from "./px-step-by-step-dialog-navigation.vue?vue&type=template&id=542bd4f4&scoped=true&ts=true"
import script from "./px-step-by-step-dialog-navigation.vue?vue&type=script&lang=ts"
export * from "./px-step-by-step-dialog-navigation.vue?vue&type=script&lang=ts"

import "./px-step-by-step-dialog-navigation.vue?vue&type=style&index=0&id=542bd4f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542bd4f4"]])

export default __exports__